module.exports = __webpack_public_path__ + "img/anxiety.72936849.png";